module.exports = __webpack_public_path__ + "img/WAW_Logo.e67a0974.webp";